<script setup>
import { useStore } from 'vuex'
import { computed } from 'vue'

import DropDownSoilType from '@/components/form/DropDownSoilType.vue'

const store = useStore()

const props = defineProps({
  addDirty: {
    type: Function,
    required: true
  },
  getDirtyClass: {
    type: Function,
    required: true
  }
})

const soilLineItems = computed(() => store.state.soilLine.items)
const currentStabSchematisationStage = computed(() => store.state.stabSchematisationStage.currentItem)
const getBaseSoilTypeItemsByRevision = computed(() => store.getters['baseSoilType/getItemsByRevision'])
const isLocked = computed(() => store.getters['stabSchematisation/isLockedCurrent'])

const setNestedParameter = (payload) => store.dispatch('soilLine/setNestedParameter', payload)

const updateValue = (item, value, parameter) => {
  setNestedParameter({
    item: item,
    value: value,
    parameter: parameter
  })
  props.addDirty(item, parameter)
}

const rightClick = (event, item) => {
  if (isLocked.value) return
  emit('rightClick', event, item)
}

const updateSelectedItem = (item) => {
  emit('update:selectedItem', item)
}

const emit = defineEmits(['rightClick', 'update:selectedItem'])
</script>

<template>
  <tbody>
    <template v-if="soilLineItems.length">
      <tr
        v-for="(item, index) in soilLineItems"
        :key="index"
        @contextmenu="rightClick($event, item)"
        @click="updateSelectedItem(item)"
      >
        <td class="pa-0" style="text-align: center">
          <span>{{ index + 1 }}</span>
        </td>
        <td class="pa-0">
          <DropDownSoilType
            :width="300"
            :items="getBaseSoilTypeItemsByRevision(currentStabSchematisationStage.soiltyperevision)"
            :item="item.base_soil_type"
            basic="true"
            @set="setNestedParameter({ item, parameter: 'base_soil_type', value: $event })"
            @addDirty="addDirty(item, 'base_soil_type')"
            :class="[getDirtyClass(item, 'base_soil_type'), isLocked ? 'disable-events' : '']"
          />
        </td>
        <td
          v-for="(coordinate, idx) in item['geometry']['coordinates']"
          :key="`${index}-${idx}`"
          class="pa-0"
          style="align-items: center"
        >
          <div
            :class="['fill-height', getDirtyClass(item, `geometry.coordinates.${idx}.1`)]"
            style="display: flex; align-items: center"
          >
            <v-text-field
              :class="[isLocked ? 'disable-events' : '', 'pl-1 custom']"
              :model-value="coordinate[1]"
              color="primary"
              density="compact"
              full-width
              hide-details
              solo
              style="font-weight: normal; border-radius: 0"
              type="number"
              variant="plain"
              @update:model-value="updateValue(item, $event, `geometry.coordinates.${idx}.1`)"
            ></v-text-field>
          </div>
        </td>
      </tr>
    </template>
    <template v-else>
      <tr>
        <td colspan="500" class="text-center">
          <span>No data available. Click "Add" to add new soil line.</span>
        </td>
      </tr>
    </template>
  </tbody>
</template>

<style scoped>
table tr > td {
  border-left: 1px solid #dddddd;
}
table tr > td:last-child {
  border-right: 0 solid #dddddd;
}

table tr > td:first-child {
  border-left: 0 solid #dddddd;
}
</style>
